package com.mgacreative.hotel

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.window
import org.jetbrains.skiko.wasm.onWasmReady
import org.koin.compose.KoinContext
import org.koin.core.context.startKoin

import com.mgacreative.hotel.shared.ui.designsystem.i18n.AppLocalizationManager

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    console.log("HotelOS WebApp initializing onWasmReady...")

    try {
        AppLocalizationManager.detectAndSetSystemLanguage(window.navigator.language)
    } catch (_: Throwable) {}

    // Auto-create canvas if missing in DOM
    if (window.document.getElementById("ComposeTarget") == null) {
        val newCanvas = window.document.createElement("canvas")
        newCanvas.id = "ComposeTarget"
        window.document.body?.appendChild(newCanvas)
    }

    try {
        startKoin {
            modules(getWebAppModules())
        }
        console.log("Koin modules initialized successfully.")
    } catch (e: Throwable) {
        console.warn("Koin notice: ${e.message}")
    }

    onWasmReady {
        console.log("Skiko WASM is ready. Mounting CanvasBasedWindow...")
        try {
            CanvasBasedWindow(title = "HotelOS", canvasElementId = "ComposeTarget") {
                KoinContext {
                    WebApp()
                }
            }
            console.log("CanvasBasedWindow mounted successfully.")
            window.asDynamic().__hotelAppMounted = true
        } catch (e: Throwable) {
            console.error("CanvasBasedWindow initialization error:", e.message, e.asDynamic().stack)
        }
    }
}
